<ion-header
  class="ion-no-border"
  [ngClass]="
    platformService?.platformType === platformService?.platformEnum?.desktop
      ? 'ion-header-modal-desktop'
      : platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-label> {{ title | translate }} </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    platformService?.platformType === platformService?.platformEnum?.desktop
      ? 'ion-content-modal-desktop'
      : platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
  "
>
  <div class="content">
    <div
      class="description"
      [class.is-touch]="
        platformService?.platformType !== platformService?.platformEnum?.desktop
      "
    >
      {{ 'i18n.productDetail.printModal.pricingOptions' | translate }}
    </div>
    <div class="checkbox">
      <ion-item lines="full">
        <ion-checkbox
          aria-label="pricing-option"
          [(ngModel)]="includeProductPrices"
          mode="ios"
          labelPlacement="start"
          justify="space-between"
        >
          <div class="label">
            {{
              'i18n.productDetail.printModal.includeProductPrices' | translate
            }}
          </div>
        </ion-checkbox>
      </ion-item>
    </div>
  </div>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        [ngClass]="
          platformService?.platformType ===
          platformService?.platformEnum?.mobile
            ? 'usf-outline-green-mobile-modal-button'
            : 'usf-outline-green-dsktp-tblt-modal-button'
        "
        (click)="closeModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        [ngClass]="
          platformService?.platformType ===
          platformService?.platformEnum?.mobile
            ? 'usf-fill-green-mobile-modal-button'
            : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        (click)="confirmAction()"
      >
        {{ confirmButton | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
